module.exports = __webpack_public_path__ + "img/sw-lx02.bfc07753.png";